import styled from 'styled-components';
import { DefaultButton } from '../../styles/globals';
import { IThemeProvider, ITheme } from '../../styles/theme';

export const CardsCont = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  ${({ theme }) => `
    margin: ${theme.layout.spacing.hekto} 0 0 0;
  `};
`;

export const CardButtonsCont = styled.div`
  position: relative;
  border-radius: 6px;
  ${({ theme }: IThemeProvider) => `
    border: 2px solid ${theme.colors.secondary[70]};
    background: ${theme.colors.neutral.primary[0]}
  `}
`;

interface ICardNavButton {
  theme: ITheme;
  active?: boolean;
}

export const CardNavButton = styled(DefaultButton)<ICardNavButton>`
  border-radius: 4px;
  height: 40px;
  border: 0;
  width: auto;
  ${({ theme, active }: ICardNavButton) => `
    padding: 0 ${theme.layout.spacing.decy};
    background: ${active ? theme.colors.secondary[100] : theme.colors.neutral.primary[0]};
    color: ${active ? theme.colors.neutral.primary[0] : theme.colors.secondary[100]};
    font-weight: ${active ? 700 : 400};
  `}
`;

export const BackButton = styled(DefaultButton)`
  position: absolute;
  height: 40px;
  display: flex;
  align-items: center;
  left: 0;
  top: 0;
  border: none;
  width: auto;
  border-radius: 8px;
  ${({ theme }: IThemeProvider) => `
     background: ${theme.colors.neutral.primary[0]};
     color: ${theme.colors.neutral.primary[100]};
     padding: 0 ${theme.layout.spacing.centy};
  `}
`;

export const ArrowCont = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  transform: rotate(180deg);
  svg {
    height: 10px;
  }
  ${({ theme }: IThemeProvider) => `
    margin:  0 ${theme.layout.spacing.mikro} 0 0;
  `}
`;
